module.exports = __webpack_public_path__ + "static/courtneybarnett-webfont-96d92b57c0e0d44fb5984ad3b430565b.woff2";